import * as React from 'react';
import { createComponent } from '@lit/react';
import { TypeaheadChangeEvent, TypeaheadWC } from './typeahead.wc';
import {
  GenerateComponentTypeWithoutChildren,
  GeneratePropsWithRef,
} from '../component-types-generics';

export type TypeaheadProps<Q> = GenerateComponentTypeWithoutChildren<
  TypeaheadWC<Q>
> & {
  onInput?: (event: TypeaheadChangeEvent<Q>) => void;
};

export type TypeaheadPropsWithRef<R> = GeneratePropsWithRef<TypeaheadProps<R>>;

const TypeaheadComponent = createComponent({
  tagName: TypeaheadWC.tagname,
  elementClass: TypeaheadWC,
  react: React,
  events: {
    onInput: 'input',
  },
}) as TypeaheadPropsWithRef<unknown>;

type TypeaheadComponentProps = React.ComponentProps<typeof TypeaheadComponent>;

export const Typeahead = <T,>(p: TypeaheadProps<T>) =>
  React.createElement(TypeaheadComponent, p as TypeaheadComponentProps);
